module.exports = __webpack_public_path__ + "static/media/rs.1fafffc0.svg";